import { CategoryDto, CategoryDtoImpl } from './categorydto';
import { SubCategoriesDto, SubCategoriesDtoImpl } from './subcategorydto';
import { DecodeHTMLEntities } from '../../../utils/decodehtmlentities';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class CategoryBuilder {
    constructor(private categoryList: any) {
        if(categoryList.categories === undefined)
        {
            throw new NoDataException("Category data doesnt exists");
        }
    }

    buildAll(): CategoryDto[] {
        return this.parseCategoryDetailsResponse();
    }

    private parseCategoryDetailsResponse(): CategoryDto[] 
    {
        console.log("createDetailsResponse() invoked");
        let decodeEntities = new DecodeHTMLEntities();
        let listOfCategoriesDetails: CategoryDto[] = [];

        let categoriesDetailsResponse = null;
        let subCategoriesDetailsResponse = null;

        this.categoryList.categories.forEach((categoriesDetails: any) => {
            
            categoriesDetailsResponse = new CategoryDtoImpl();
            categoriesDetailsResponse.setId(categoriesDetails.categoryId);
            categoriesDetailsResponse.setTitle(decodeEntities.decodeHTMLEntities(categoriesDetails.categoryName));
            categoriesDetailsResponse.setImgPath(categoriesDetails.menuImagePath);

            let listOfSubCategories: SubCategoriesDto[] = [];

            if (categoriesDetails.subCategoryList !== undefined) 
            {
                categoriesDetails.subCategoryList.forEach((subCategoriesDetails: any) => {
            
                    subCategoriesDetailsResponse = new SubCategoriesDtoImpl();
                    subCategoriesDetailsResponse.setCategoryId(subCategoriesDetails.categoryId);
                    subCategoriesDetailsResponse.setCategoryName(decodeEntities.decodeHTMLEntities(subCategoriesDetails.categoryName));
                    subCategoriesDetailsResponse.setCdpCategoryId(subCategoriesDetails.cdpCategoryId);
                    subCategoriesDetailsResponse.setCdpCategoryName(subCategoriesDetails.cdpCategoryName);
                    subCategoriesDetailsResponse.setSubCdpCategoryId(subCategoriesDetails.subCdpCategoryId);

                    listOfSubCategories.push(subCategoriesDetailsResponse);
                });
                categoriesDetailsResponse.setSubCategoriesList(listOfSubCategories);
            }
            listOfCategoriesDetails.push(categoriesDetailsResponse);
        });

        console.log("-------listOfCategoriesDetails: " + JSON.stringify(listOfCategoriesDetails));
        return listOfCategoriesDetails;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/categories/categorybuilder.ts